
/*
  openUrlType：3.6版本以后，支持在软件内弹出独立的Wb
  说明：1:IEBrowser,0:Chrome，2:IE，p.openUrlType,3:Wb, 50 mb
  新ie内核 type =100  用默认ie内核打开，type = 106、107、108、109、110、111 分别为6、7、8、9、10、11 内核打开

  7.1.6 新增拦截字符串（拦截请求） 多个逗号隔开
  adsVector 例："baidu,Google"
*/
export const partnerConfig = {
  '9801': {
    name: '人保',
    py: 'Renbao',
    jp: 'rb',
    sortNum: 1,
    openUrlType: 1,
    hasHelp: true,
    hasPlugins: true,
    closeBrowser: true,
    abb: '全国新出单系统',
    url: 'https://icar.epicc.com.cn:8443/icar/',
    specialConfigs: {
      '北京市': {
        py: 'Renbaobeijing',
        jp: 'rbbj',
        url: 'https://10.134.136.48:8888/casserver/login?service=http%3A%2F%2F10.134.136.48%3A8000%2Fprpall%2Findex.jsp',
        openUrlType: 1
      },
      '天津市': {
        py: 'Tianjinbeijing',
        jp: 'rbtj',
        url: 'https://10.134.131.48:8888/casserver/login?service=http%3A%2F%2F10.134.131.48%3A80%2Fportal%2Findex.jsp',
        openUrlType: 1
      },
      '河南省': {
        py: 'Renbaohenan',
        jp: 'rbhn',
        url: 'https://10.134.132.176:8888/casserver/login?service=http%3A%2F%2F10.134.132.176%3A80%2Fportal%2Findex.jsp',
        openUrlType: 107
      },
      '河北省': {
        url: 'https://10.134.138.112:8888/casserver/login?service=http%3A%2F%2F10.134.138.112%3A80%2Fportal%2Findex.jsp',
        py: 'Renbaohebei',
        jp: 'rbhb',
        openUrlType: 107
      },
      '陕西省': {
        url: 'https://10.134.131.80:8888/casserver/login?service=http%3A%2F%2F10.134.131.80%3A80%2Fportal%2Findex.jsp',
        py: 'Renbaoshanxi',
        jp: 'rbsxi',
        openUrlType: 1
      },
      '吉林省': {
        py: 'Renbaojilin',
        jp: 'rbjl',
        url: 'https://10.134.130.80:8888/casserver/login?service=http%3A%2F%2F10.134.130.80%3A80%2Fportal%2Findex.jsp',
        openUrlType: 1
      },
      '辽宁省': {
        py: 'Renbaoliaoning',
        jp: 'rbtj',
        url: 'https://10.134.129.16:8888/casserver/login?service=http%3A%2F%2F10.134.129.16%3A80%2Fportal%2Findex.jsp',
        openUrlType: 1
      },
      '江西省': {
        py: 'Renbaojiangxi',
        jp: 'rbjx',
        url: 'https://10.134.132.48:8888/casserver/login?service=http%3A%2F%2F10.134.132.48%3A80%2Fportal%2Findex.jsp',
        openUrlType: 1
      },
      '湖南省': {
        py: 'Renbaohunan',
        jp: 'rbhn',
        url: 'https://10.134.132.16:8888/casserver/login;jsessionid=Gf53ZRpTFQYC2QTHmDk1vLlpH7pQgy1Gd81KwF21DyTbJkh15dhG!-504479112?service=http%3A%2F%2F10.134.132.16%3A80%2Fportal%2Findex.jsp',
        openUrlType: 1
      },
      '湖南省（市人保）': {
        py: 'Renbaohunansrb',
        jp: 'rbhn',
        url: 'https://10.134.132.16:8888/casserver/login;jsessionid=Gf53ZRpTFQYC2QTHmDk1vLlpH7pQgy1Gd81KwF21DyTbJkh15dhG!-504479112?service=http%3A%2F%2F10.134.132.16%3A80%2Fportal%2Findex.jsp',
        openUrlType: 3,
        isVpnChangeServer: 1
      },
      '湖北省': {
        py: 'Renbaohubei',
        jp: 'rbhb',
        url: 'https://10.134.134.80:8888/casserver/login?service=http%3A%2F%2F10.134.134.80%3A80%2Fportal%2Findex.jsp',
        openUrlType: 107
      },
      '四川省': {
        py: 'Renbaosichuan',
        jp: 'rbsc',
        url: 'https://10.134.138.16:8888/casserver/login?service=http%3A%2F%2F10.134.138.16%3A80%2Fportal%2Findex.jsp',
        openUrlType: 1
      },
      '广东省': {
        py: 'Renbaoguangdong',
        jp: 'rbgd',
        url: 'https://10.134.138.48:8888/casserver/login?service=http%3A%2F%2F10.134.138.48%3A80%2Fportal%2Findex.jsp',
        openUrlType: 1
      },
      '山东省': {
        py: 'Renbaoshandong',
        jp: 'rbsd',
        url: 'https://10.134.136.80:8888/casserver/login?service=http%3A%2F%2F10.134.136.80%3A80%2Fportal%2Findex.jsp',
        openUrlType: 1
      },
      '人保营销系统': {
        isfav: false,
        py: 'Renbaoyingxiaoshandong',
        jp: 'rbsd',
        url: 'http://157.122.153.67:9000/khyx/',
        openUrlType: 1
      },
      '安徽省': {
        py: 'Renbaoanhui',
        jp: 'rbah',
        url: 'https://10.134.138.80:8888/casserver/login?service=http%3A%2F%2F10.134.138.80%3A80%2Fportal%2Findex.jsp',
        openUrlType: 1
      },
      '山东省青岛市': {
        py: 'Renbaoqingdao',
        jp: 'rbqd',
        url: 'https://10.134.134.48:8888/casserver/login?service=http%3A%2F%2F10.134.134.48%3A80%2Fportal%2Findex.jsp',
        openUrlType: 1
      },
      '山西省': {
        py: 'Renbaoshanx',
        jp: 'rbsx',
        url: 'https://10.134.134.144:8888/casserver/login?service=http%3A%2F%2F10.134.134.144%3A8000%2Fprpall%2Findex.jsp%3F__sys__%3D2',
        openUrlType: 1
      },
      '山西省人保综合系统': {
        // isfav: true,
        py: 'Renbaozonghe',
        jp: 'rbzh',
        url: 'https://10.134.134.144:8888/casserver/login?service=http%3A%2F%2F10.134.134.144%3A80%2Fportal%2Findex.jsp',
        openUrlType: 1
      },
      '山西省人保单证系统': {
        // isfav: true,
        py: 'Renbaodanzheng',
        jp: 'zrbdz',
        url: 'https://10.134.134.144:8888/casserver/login?service=http%3A%2F%2F10.134.134.144%3A8900%2Fvisa%2Fmiddle.jsp',
        openUrlType: 1
      },
      '内蒙古': {
        py: 'Renbaoneimenggu',
        jp: 'rbnmg',
        url: 'https://10.134.134.112:8888/casserver/login?service=http%3A%2F%2F10.134.134.112%3A80%2Fportal%2Findex.jsp',
        openUrlType: 1
      },
      '新疆': {
        url: 'https://10.134.129.80:8888/casserver/login?service=http%3A%2F%2F10.134.129.80%3A80%2Fportal%2Findex.jsp',
        py: 'Renbaoxinjiang',
        jp: 'rbxj',
        openUrlType: 1
      },
      '新疆人保营销(外)': {
        isfav: true,
        url: 'http://157.122.153.67:9000/khyx/',
        py: 'Renbaoxinjiangyingxiaoxitongwaiwang',
        jp: 'xjrbyxxtww',
        openUrlType: 1
      },
      '新疆人保营销(内)': {
        isfav: true,
        url: 'http://10.133.240.239:9000/khyx/login.jsp;jsessionid=k9K4WC1GQr6s2LM0nG7pDVhc6G8vQHj6bhbCWw8GwJFny1vDQS4H!1140367973',
        py: 'Renbaoxinjiangyingxiaoxitongneiwang',
        jp: 'xjrbyxxtnw',
        openUrlType: 1
      },
      '江苏省': {
        url: 'https://10.134.136.112:8888/casserver/login?service=http%3A%2F%2F10.134.136.112%3A80%2Fportal%2Findex.jsp',
        py: 'Renbaojiangsu',
        jp: 'rbjs',
        openUrlType: 107
      },
      '江苏省保险信息综合查询系统': {
        url: 'http://88.32.0.232:88/sinoiais/',
        py: 'jiangsubaoxianzonghe',
        jp: 'jsrbx',
        openUrlType: 1,
        isfav: true
      },
      '贵州省': {
        url: 'https://10.134.134.176:8888/casserver/login?service=http%3A%2F%2F10.134.134.176%3A8000%2Fprpall%2Findex.jsp',
        py: 'Renbaoguizhou',
        jp: 'rbgz',
        openUrlType: 1
      },
      '黑龙江省': {
        url: 'https://10.134.130.16:8888/casserver/login?service=http%3A%2F%2F10.134.130.16%3A80%2Fportal%2Findex.jsp',
        py: 'Renbaoheilongjiang',
        jp: 'rbhlj',
        openUrlType: 1
      },
      'PICC新车险省间通赔系统': {
        url: 'http://10.133.240.24/piccclaim/acegilogin.jsp;jsessionid=5pR3ZFHGbZhY34Qhjqh4HFGz2G7cc2pJqzhGnKQlsV4Smbv4RQC4!-594149458!249232847',
        py: 'PICCxsjtongpeixitong',
        jp: 'PICCxcxsjtpxt',
        openUrlType: 1
      },
      'PICC新车险理赔系统': {
        url: 'http://10.134.139.120:8000/piccclaim/index/switchToOld.do',
        py: 'PICCxinchexianlipeixitong',
        jp: 'PICCxcxlpxt',
        openUrlType: 1
      },
      'PICC零部件价格综合管理平台': {
        url: 'http://10.133.240.81/PartsManageSP/login.jsp',
        py: 'lingbujianjiagechaxunxitong',
        jp: 'lbjjgcxxt',
        openUrlType: 1
      },
      'PICC非车险承保系统': {
        url: 'http://10.134.138.114:8000/prpins/?calogin',
        py: 'feichechangbaoxitong',
        jp: 'fccbxt',
        openUrlType: 1
      },
      'PICC新收付费系统': {
        url: 'https://10.134.129.16:8888/casserver/login?service=http%3A%2F%2F10.134.129.16%3A9100%2Fpiccsff%2Fmain.jsp',
        py: 'xinshoufufeixitong',
        jp: 'xsffxt',
        openUrlType: 1
      },
      '河北人保省间': {
        url: 'http://10.133.240.24/piccclaim/acegilogin.jsp;jsessionid=5pR3ZFHGbZhY34Qhjqh4HFGz2G7cc2pJqzhGnKQlsV4Smbv4RQC4!-594149458!249232847',
        py: 'hebeirenbaoshenjian',
        jp: 'fbrbsj',
        openUrlType: 1
      },
      '河北人保省内': {
        url: 'http://10.134.139.120:8000/piccclaim/index/switchToOld.do',
        py: 'hebeirenbaoshennei',
        jp: 'hbrbsn',
        openUrlType: 1
      },
      '湖北营销管理系统': {
        url: 'http://10.133.240.239:9000/khyx/login.jsp',
        py: 'hubeiyingxiaoguanlixitong',
        jp: 'hbyxglxt',
        openUrlType: 1
      },
      '海南省': {
        url: 'https://10.134.128.80:8888/casserver/login?service=http%3A%2F%2F10.134.128.80%3A80%2Fportal%2Findex.jsp',
        py: 'renbaohainan',
        jp: 'rbhn',
        openUrlType: 1
      },
      '浙江省': {
        url: 'https://10.134.136.16:8888/casserver/login?service=http%3A%2F%2F10.134.136.16%3A80%2Fportal%2Findex.jsp',
        py: 'renbaozhejiang',
        jp: 'rbhn',
        openUrlType: 1
      },
      '湖北人保客户查询系统': {
        url: 'http://52.1.32.156:9060/cust',
        py: 'hubeirenbaokehuchaxun',
        jp: 'hbrbkhcx',
        openUrlType: 1
      }
    },
    usable: true,
    capacityCount: 10,
    ukey: true,
    logo: 'renbao.jpg',
    visible: false,
    color: '#FA0004',
    machine: true

  },
  '9802': {
    name: '太平洋（旧版）',
    py: 'Taibao',
    jp: 'tpy',
    hasPlugins: true,
    sortNum: 2,
    openUrlType: 1,
    url: 'http://autoagent.cpic.com.cn:8081/CPIC09Auto/pages/policynewbiz/queryapplication/query.jsp',
    usable: true,
    color: '#067BE2',
    logo: 'taipingyang.jpg',
    specialConfigs: {
      '太平洋（旧版）': {
        url: 'http://autoagent.cpic.com.cn:8081/CPIC09Auto/pages/policynewbiz/queryapplication/query.jsp',
        py: 'taipingyangjiuban',
        jp: 'tpyjb',
        openUrlType: 0
      },
      '太平洋P09车险承保系统': {
        url: 'http://10.190.48.28/CPIC09Auto/pages/loginView.jsp?error=usererror',
        py: 'taipingyangP09',
        jp: 'tpyP09',
        openUrlType: 1
      }
    }
  },
  '9803': {
    name: '平安',
    py: 'Pingan',
    capacityCount: 9,
    jp: 'pa',
    sortNum: 3,
    openUrlType: 0,
    adsVector: 'cisplugin.js',
    url: 'https://icore-pts.pingan.com.cn/ebusiness/auto/newness/toibcswriter.do?transmitId=apply',
    usable: true,
    logo: 'pingan.jpg',
    color: '#EF5A22',
    bindMac: true,
    specialConfigs: {
      '产险合作伙伴交易服务平台': {
        url: 'https://pacas-login.pingan.com.cn/cas/PA003/ICORE_PTS/login',
        py: 'Pinganum',
        jp: 'paum',
        indexurl: 'https://icore-pts.pingan.com.cn/ebusiness/login.do',
        adsVector: 'cisplugin.js'
      },
      '产险业务新核心系统': {
        adsVector: 'cisplugin.js',
        url: 'https://icorepnbs.pingan.com.cn/icore_pnbs/extranet_login.jsp',
        py: 'Pinganxinhexin',
        jp: 'paxhx',
        indexurl: ''
      },
      '平安创展核心管理系统': {
        adsVector: 'cisplugin.js',
        url: 'https://pacz.pa18.com/cms/#/user/login',
        py: 'Pinganchuangzhan',
        jp: 'pacz',
        indexurl: 'http://pacz.pa18.com/pacz_core/docc/mainPage.jsp'
      },
      '平安e行销': {
        adsVector: 'cisplugin.js',
        url: 'https://ecpub.pingan.com/login.jsp',
        py: 'Pingananhui',
        jp: 'paah',
        sharejobno: 1
      },
      '平安e行销签单查询': {
        adsVector: 'cisplugin.js',
        url: 'https://ecpub.pingan.com/login.jsp',
        py: 'Pinganqiandan',
        jp: 'paqd',
        sharejobno: 1
      },
      '平安e行销大工号': {
        adsVector: 'cisplugin.js',
        url: 'https://ecss.pingan.com/login.jsp',
        py: 'Pingandagonghao',
        jp: 'padgh',
        sharejobno: 1
      },
      '平安创保网': {
        adsVector: 'cisplugin.js',
        url: 'https://www.czbx18.com/cbwMobile/resources/cbwStyle/html5/login/login.html?time=346&from=singlemessage',
        py: 'pinganchuangbao',
        jp: 'pacb',
        sharejobno: 1
      }

    }
  },
  '9818': {
    name: '国寿财',
    py: 'Guoshoucai',
    jp: 'gsc',
    sortNum: 6,
    capacityCount: 6,
    usable: true,
    openUrlType: 1,
    url: 'http://9.0.6.69:7001/prpall/index.jsp',
    vpn: true,
    color: '#138F4F',
    logo: 'guoshoucai.jpg',
    hasPlugins: true,
    specialConfigs: {
      '国寿财内网打印系统': {
        py: 'guoshoucaineiwangdayin',
        jp: 'gscnwdy',
        url: 'http://9.0.6.7:7081/carQuoteSystem/login.jsp',
        sharejobno: 1
      },
      '国寿驾乘出单网址': {
        py: 'guoshouchengjia',
        jp: 'gscj',
        url: 'http://eshop.e-chinalife.com/'
      },
      '国寿财新核心系统': {
        py: 'guoshouxinhexin',
        jp: 'gsxhx',
        openUrlType: 0,
        url: 'http://9.0.9.11/workbench/workbench/login.html'
      }
    }
  },
  '9804': {
    name: '紫金',
    py: 'Zijin',
    jp: 'zj',
    sortNum: 26,
    usable: true,
    openUrlType: 3,
    color: '#533E8B',
    url: 'http://prpall01.zking.com:8001/prpall/index.jsp',
    vpn: true,
    logo: 'zijin.jpg',
    hasPlugins: true,
    bindMac: true,
    specialConfigs: {
      '紫金出单系统': {
        py: 'zijinchudan',
        jp: 'zjcd',
        sharejobno: 1,
        openUrlType: 0,
        url: 'https://kscd.zking.com:10443/login.html'
        // url: "http://114.251.1.147:8897/ipartner"
      },
      '紫金影像管理系统': {
        py: 'zijinyingxiangguanlixitong',
        jp: 'zjyxglxt',
        sharejobno: 1,
        openUrlType: 0,
        url: 'http://88.0.33.51/webcamera/index.aspx'
        // url: "http://114.251.1.147:8897/ipartner"
      }
    }

  },
  '9805': {
    name: '中华联合',
    py: 'Zhonghualianhe',
    jp: 'zhlh',
    sortNum: 4,
    color: '#CE1912',
    openUrlType: 3,
    usable: true,
    url: 'http://carply.cic.cn',
    logo: 'zhonghua.jpg',
    hasPlugins: true,
    specialConfigs: {
      '极速出单系统': {
        py: 'Zhonghualianhejisu',
        jp: 'zhlhjs',
        sharejobno: 1,
        openUrlType: 100,
        url: 'http://jscd.cic.cn:8897/ipartner/index'
        // url: "http://114.251.1.147:8897/ipartner"
      },
      '中华联合地区系统': {
        py: 'Zhonghualianhediqu',
        jp: 'zhlhdq',
        url: 'http://sso.cic.inter/cas/login?service=http%3A%2F%2F10.192.0.22%2Fpcis%2Fj_spring_cas_security_check'
      },
      '中华联合影像': {
        py: 'Zhonghualianheyingxinag',
        jp: 'zhlhyx',
        url: 'http://222.33.33.27:88/'
      },
      '中华联合单证管理': {
        py: 'Zhonghualianhedanzhenggunali',
        jp: 'zhlhdzgl',
        url: 'http://10.192.0.77/visa/userPower/ssoLogin.do'
      },
      '中华联合内网出单': {
        py: 'Zhonghualianheneiwangchudan',
        jp: 'zhlhnwcd',
        url: 'http://10.192.48.47/cas/login?service=http%3A%2F%2F10.192.0.22%2Fpcis%2Fj_spring_cas_security_check'
      }
      // "北京市": {
      //    py: "Zhonghualianhebeijing",
      //    jp: "zhlhbj",
      //    url: "http://10.192.0.22/pcis/core/pcis_main.jsp", //"http://10.192.32.69:8001/pcis/core/pcis_main.jsp"
      // },
      // "湖北省": {
      //    py: "Zhonghualianhehubei",
      //    jp: "zhlhhb",
      //    url: "http://10.192.0.22"
      // },
      // "陕西省": {
      //    py: "Zhonghualianheshanxi",
      //    jp: "zhlhsx",
      //    url: "http://10.192.0.22"
      // },
      // "吉林省": {
      //    py: "Zhonghualianhejilin",
      //    jp: "zhlhjl",
      //    url: "http://10.192.0.22/pcis/core/pcis_main.jsp"
      // }
    }
  },
  '9806': {
    name: '永诚',
    py: 'Yongcheng',
    jp: 'yc',
    sortNum: 12,
    openUrlType: 1,
    color: '#de2c37',
    batch: true,
    url: 'http://www.95552.cc:8005/cas/login?service=http%3A%2F%2Fwww.95552.cc%3A16800%2Fpcis%2Fj_spring_security_check',
    usable: true,
    logo: 'yongcheng.jpg',
    hasPlugins: true,
    specialConfigs: {
      '永诚理赔管理系统': {
        url: 'https://www.95552.cc:8001/fasttrack/pages/Frame/Login.aspx',
        py: 'YongChengLiPeiGuanLi',
        jp: 'YGLPGL',
        sharejobno: 1,
        openUrlType: 0
      }
    }
  },
  '9807': {
    name: '华泰',
    py: 'Huatai',
    color: '#014190',
    openUrlType: 108,
    url: 'http://172.16.100.37:9999/htcsp/ShakeHandsAction.do?cmd=exitLogin',
    sortNum: 13,
    jp: 'ht',
    usable: true,
    vpn: true,
    logo: 'huatai.jpg',
    hasPlugins: true,
    specialConfigs: {
      '华泰（旧）': {
        py: 'Huataijiu',
        jp: 'htj',
        sharejobno: 1,
        url: 'http://172.16.100.37:8888/index.jsp',
        openUrlType: 1
      },
      '新单证系统': {
        py: 'Xindanzhengxitong',
        jp: 'xdzxt',
        sharejobno: 1,
        url: 'http://172.16.100.37:9021/#/login',
        openUrlType: 0
      },
      '销管系统': {
        py: 'Xiaoguanxitong',
        jp: 'xgxt',
        sharejobno: 1,
        url: 'http://172.16.100.28:9021/',
        // openUrlType: 0
        openUrlType: 0
      }
    }
  },
  '9808': {
    name: '安盛',
    py: 'Ansheng',
    jp: 'as',
    openUrlType: 1,
    color: '#034790',
    url: 'https://apps.axatp.com/auto/index.do',
    sortNum: 5,
    batch: true,
    usable: true,
    logo: 'tianping.jpg'
  },
  '9809': {
    name: '太平',
    py: 'Taiping',
    jp: 'tp',
    sortNum: 6,
    color: '#318D3A',
    openUrlType: 1,
    url: 'http://auto.tpi.cntaiping.com',
    usable: true,
    logo: 'taiping.jpg',
    specialConfigs: {
      '太平网销': {
        py: 'Taipingxinwangxiao',
        jp: 'tpwx',
        sharejobno: 1,
        url: 'https://quote.tpi.cntaiping.com/OuterLogin.do'
      },
      // "太平新网址":{
      //     py:"Taipingxinwangzhi",
      //     jp:"tpxwz",
      //     sharejobno: 1,
      //     url:"https://auto.tpi.cntaiping.com:8002/",
      // },
      '太平2018版': {
        py: 'Taiping2018ban',
        jp: 'tp2018b',
        sharejobno: 1,
        openUrlType: 108,
        url: 'https://auto.tpi.cntaiping.com:8002/'
      },
      '电子保单下载': {
        py: 'dianzibaodan',
        jp: 'dzbd',
        openUrlType: 200,
        url: 'http://ectp.tpi.cntaiping.com/TPEBizWeb/pages/B2C/show/dentistryShow.do'
      }
    }
  },
  '9810': {
    name: '华安',
    py: 'Huaan',
    sortNum: 22,
    openUrlType: 100,
    color: '#920201',
    jp: 'ha',
    usable: true,
    logo: 'huaan.jpg',
    url: 'http://auto.sinosafe.com.cn/index.jsp',
    hasPlugins: true,
    specialConfigs: {
      '吉林省': {
        py: 'Huaanjilin',
        jp: 'hajl',
        url: 'https://auto.sinosafe.com.cn/index.jsp'
      },
      '华安新系统': {
        py: 'HuaanB2B',
        jp: 'haB2B',
        openUrlType: 100,
        sharejobno: 1,
        url: 'http://www.sinosafe.com.cn/eb-web/car/pc/login.html'
      }
    }
  },
  '9811': {
    name: '大家保险',
    py: 'Dajiabaoxian',
    jp: 'djbx',
    sortNum: 23,
    openUrlType: 1,
    color: '#D0192F',
    usable: true,
    vpn: true,
    logo: 'anbang.jpg',
    url: 'http://eabsys.abic.com/portal/',
    hasPlugins: true,
    specialConfigs: {
      '大家保险车险快速出单': {
        py: 'Dajiabaoxianchexiankuaisuchudan',
        jp: 'djbxcxkscd',
        url: 'http://10.5.82.66:8080/new-uauto-web/doc/home.html',
        // url:"http://eabsys.abic.com:8080/cas/login?service=http%3A%2F%2F10.5.82.66%3A8080%2Fnew-uauto-web%2Fdoc%2Fhome.html",
        openUrlType: 0
      }
    }
  },
  '9813': {
    name: '阳光',
    py: 'Yangguang',
    jp: 'yg',
    openUrlType: 3,
    color: '#F7AB07',
    batch: true,
    logo: 'yangguang.jpg',
    url: 'https://wwcd.sinosig.com/prpall/index.jsp', // 险种选择0507,0528
    sortNum: 11,
    usable: true,
    specialConfigs: {
      '广东省': {
        py: 'Yangguangguangdong',
        jp: 'yggd',
        url: 'http://10.10.0.20/prpall/index.jsp'
      },
      '江苏阳光增值税管理平台': {
        py: 'Yangguangzengzhishui',
        jp: 'ygzzs',
        url: 'http://10.8.222.26/ptxlogin/login/login.jsp'
      },
      '阳光全能宝算单系统': {
        py: 'Yangguangquannengbao',
        jp: 'ygqnb',
        openUrlType: 0,
        url: 'http://eamd.sinosig.com:8080/SinoSig/'
      },
      '阳光快速系统': {
        py: 'Yangguangkuaisuxitong',
        jp: 'ygksxt',
        openUrlType: 0,
        url: 'http://kybpc.chexian.sinosig.com/easyInsurance/html5/login.html'
      },
      '独立保险代理人管理系统': {
        py: 'Dulibaoxiandailirenguanlixitong',
        jp: 'dlbxdlrglxt',
        openUrlType: 0,
        url: 'http://eamd.sinosig.com:8080/SinoSig/'
      }
    }
  },
  '9814': {
    name: '泰山',
    py: 'Taishan',
    jp: 'ts',
    sortNum: 10,
    color: '#5CB85C',
    openUrlType: 1,
    logo: 'taishan.jpg',
    url: 'http://10.1.3.15:7001/cas/login?service=http%3A%2F%2F10.1.3.12%3A7001%2Fportal%2Fj_spring_security_check%3Bjsessionid%3Dm3J4bd5JhGvTnYGKghbnHJ9Hy8qJncgPs0R4TjnJCyvX6XygKZdY%211375055806',
    usable: true,
    vpn: true,
    specialConfigs: {
      '泰山（旧）': {
        url: 'http://10.1.3.163:7001/pcis/core/main.jsp',
        py: 'Taishanjs',
        jp: 'taishanjs',
        openUrlType: 1
      },
      '泰山车险理赔系统': {
        url: 'http://10.1.7.4/autoclaim/LoginServlet',
        py: 'Taishanchexianlipeixitong',
        jp: 'tscxlpxt',
        openUrlType: 1
      }
    } // ,
    // hasPlugins: true
  },
  '9815': {
    name: '永安',
    py: 'Yongan',
    jp: 'ya',
    sortNum: 9,
    hasPlugins: true,
    color: '#FA060D',
    openUrlType: 1,
    url: 'http://10.2.68.99:6666/casserver/login?service=http%3A%2F%2F10.2.66.99%3A6661%2Fprpall%2Findex.jsp',
    usable: true,
    vpn: true,
    logo: 'yongan.jpg',
    specialConfigs: {
      '永安保单影像系统': {
        url: 'http://10.149.9.151',
        py: 'Yonganyingxiang',
        jp: 'yayx',
        openUrlType: 108
      },
      '永安核心业务系统': {
        url: 'http://10.0.69.103:6101/pcis/core/pcis_main.jsp?passExpired=true',
        py: 'yonganhexinyewu',
        jp: 'yahxyw'
      },
      '非车险承保系统': {
        url: 'http://10.0.66.99:6100/cas/login?service=http%3A%2F%2F10.0.69.113%3A6201%2Fpcis%2Fj_spring_security_check',
        py: 'feichexianchengbaoxitong',
        jp: 'fcxcbxt',
        openUrlType: 107
      }
    }
  },
  '9816': {
    name: '大地',
    py: 'Dadi',
    jp: 'dd',
    logo: 'dadi.jpg',
    color: '#095D8C',
    sortNum: 8,
    openUrlType: 1,
    url: 'https://vpn1.ccic-net.com.cn:10001/ddccallweb/index.jsp',
    usable: true,
    specialConfigs: {
      '河南省': {
        url: 'https://vpn.ccic-net.com.cn',
        py: 'Dadihenan',
        jp: 'ddhn'
      },
      '山东省': {
        py: 'Dadishandong',
        jp: 'ddsd',
        url: 'https://vpn.ccic-net.com.cn'
      },
      '中国大地保险': {
        url: 'https://sso.ccic-net.com.cn/casserver/login?param=icore',
        py: 'Zhongguodadibaoxian',
        jp: 'zgddbx',
        openUrlType: 100
      }
    }
  },
  '9817': {
    name: '申能财险',
    py: 'shenneng',
    jp: 'sn',
    color: '#14944A',
    hasPlugins: true,
    sortNum: 24,
    usable: true,
    openUrlType: 1,
    url: 'http://sso.tianan-insurance.com/login',
    vpn: true,
    logo: 'tianan.jpg',
    specialConfigs: {
      '天安网销': {
        url: 'http://cy.95505.cn:9005/index.action?action=initIndex',
        py: 'tiananwangxiao',
        jp: 'tawx',
        sharejobno: 1,
        openUrlType: 0
      },
      '天安财险': {
        url: 'http://esale.95505.cn:9005/user/user.action?action=initLogin',
        py: 'tianancaixian',
        jp: 'tacx',
        openUrlType: 0
      },
      '天安保单影像系统': {
        url: 'http://10.31.1.99',
        py: 'tiananbdyxxt',
        jp: 'tayx',
        openUrlType: 108
      },
      '天安保单极速出单网': {
        url: 'https://netauto.95505.cn/login#/login',
        py: 'tiananjscdw',
        jp: 'tayx',
        openUrlType: 0
      }
    }
  },

  '9819': {
    name: '英大',
    py: 'Yingda',
    jp: 'yd',
    color: '#056F6F',
    sortNum: 7,
    vpn: true,
    usable: true,
    abb: '英大老系统',
    openUrlType: 1,
    url: 'http://10.0.130.220/ydcc/',
    logo: 'yingda.jpg',
    hasPlugins: true,
    specialConfigs: {
      '极速版': {
        url: 'http://10.0.130.227/app/#/',
        py: 'Yingdajs',
        jp: 'ydjs',
        openUrlType: 0,
        hasPlugins: true
      }
    }
  },
  '9820': {
    name: '华农',
    py: 'Huanong',
    jp: 'hn',
    sortNum: 25,
    color: '#597EB5',
    openUrlType: 50,
    batch: true,
    url: 'https://cx.chinahuanong.com.cn/',
    usable: true,
    logo: 'huanong.jpg'
  },
  '9821': {
    name: '中煤',
    py: 'Zhongmei',
    jp: 'zm',
    sortNum: 25,
    hasPlugins: true,
    color: '#F37600',
    openUrlType: 1,
    url: 'http://10.1.0.50:7000/casserver/login?service=http://auto.chinacoal-ins.com/j_acegi_security_check',
    usable: true,
    vpn: true,
    logo: 'zhongmei.jpg',
    specialConfigs: {
      '快速出单系统': {
        url: 'https://kscd.echinacoal.com',
        py: 'ZhongmeiJisu',
        jp: 'zmjs',
        sharejobno: 1,
        openUrlType: 0
      }
    }
  },
  '9822': {
    name: '富德',
    py: 'Fude',
    jp: 'fd',
    sortNum: 25,
    color: '#C72F2C',
    openUrlType: 1,
    url: 'https://www.sino-life.com/elogin/LOGIN/domain-1/login.html?toURL=http%3A%2F%2Fwww.sino-life.com%2Feportal%2Findex.do',
    usable: true,
    logo: 'fude.jpg',
    hasPlugins: true,
    specialConfigs: {
      '核心系统': {
        url: 'http://192.168.140.24/SsoLogin.sso',
        py: 'FuDeHeXinXiTong',
        jp: 'fdhxxt',
        openUrlType: 1
      },
      '富德PIMP': {
        url: 'http://58.250.41.21/pimp',
        py: 'FuDePIMP',
        jp: 'fdpimp',
        openUrlType: 1
      },
      '富德打印': {
        url: 'http://m.fundins.com/print/',
        py: 'FuDeDaYin',
        jp: 'fddy',
        openUrlType: 1
      }
    }
  },
  '9823': {
    name: '国任',
    py: 'GuoRen',
    jp: 'gr',
    vpn: true,
    sortNum: 25,
    color: '#b58a45',
    usable: true,
    openUrlType: 1,
    logo: 'xinda.jpg',
    hasPlugins: true,
    url: 'http://10.75.1.10:8001/prpall/index.jsp',
    specialConfigs: {
      '国任新网址': {
        // url: "https://rbt.guorenpcic.com/ecar/#/queryRoot/list",
        url: 'https://rbt.guorenpcic.com/ecar/#/login',
        py: 'GuoRenxinwangzhi',
        jp: 'grxwz',
        openUrlType: 0
      },
      '国任保单影像系统': {
        url: 'http://10.75.5.73/webcamera',
        py: 'GuoRenbdyxxt',
        jp: 'gryx',
        openUrlType: 108
      },
      '国任电子保单下载系统': {
        url: 'http://www.guorenpcic.com/wap/bdyz/index.jhtml',
        py: 'GuoRendzbdxz',
        jp: 'grdzbdxz',
        openUrlType: 200
      }
    }
  },
  '9824': {
    name: '亚太',
    py: 'Yatai',
    color: '#043680',
    jp: 'yt',
    usable: true,
    hasPlugins: true,
    openUrlType: 1,
    url: 'https://qcar.apiins.com/qcar/',
    logo: 'yatai.jpg',
    sortNum: 25
  },
  '9870': {
    name: '太平洋',
    py: 'TaiPingYang',
    jp: 'tpy',
    openUrlType: 0,
    color: '#057ADA',
    hasPlugins: true,
    capacityCount: 8,
    usable: true,
    url: 'http://issue.cpic.com.cn/ecar/view/portal/page/common/login.html',
    sortNum: 25,
    logo: 'taipingyang.jpg',
    specialConfigs: {
      '太平洋影像': {
        url: 'http://218.25.61.74:7000/webcamera/index.aspx',
        py: 'taipingyangyingxiang',
        jp: 'tpyyx',
        openUrlType: 111
      }
    }
  },
  '9851': {
    name: '燕赵',
    py: 'Yanzhao',
    jp: 'yz',
    vpn: true,
    openUrlType: 3,
    color: '#2463a6',
    usable: true,
    hasPlugins: true,
    logo: 'yanzhao.jpg',
    url: 'http://10.1.135.12:8000/casserver/login?service=http%3A%2F%2F10.1.135.13%2F%2Fj_acegi_security_check%3BsinosoftJSESSIONID%3DtD_N5zrPk9hG22XHrAfvOscZpUKiX-q5d6Tvb1-UiK2y536ONGqV%212075847925',
    sortNum: 52
  },
  '9869': {
    name: '渤海',
    py: 'Bohai',
    color: '#2676c6',
    jp: 'bh',
    vpn: true,
    url: 'http://pc.bpic.com.cn/prpall/',
    sortNum: 70,
    logo: 'bohai.jpg',
    usable: true,
    specialConfigs: {
      '渤海极速系统': {
        py: 'Bohaihenan',
        jp: 'bhhn',
        url: 'http://pspcc.bpic.com.cn/app/#/proposal/',
        openUrlType: 0
      },
      '渤海影像': {
        py: 'Bohaiyingxiang',
        jp: 'bhyx',
        url: 'http://10.1.72.4/webcamera/index.aspx'
      }
    }
  },
  '9868': {
    name: '安盟保险',
    py: 'Zhonghanganmeng',
    jp: 'zham',
    color: '#086B32',
    url: 'https://aiu.groupama-avic.com.cn:7011/prpall/index.jsp',
    sortNum: 69,
    logo: 'zhonghanganmeng.jpg',
    hasPlugins: true,
    usable: true,
    specialConfigs: {
      '安盟保险（新）': {
        py: 'Zhonghanganmengxin',
        jp: 'zhamx',
        url: 'http://motor.groupama-avic.com.cn:7001/prpall/',
        openUrlType: 107
      },
      '安盟保险理赔系统': {
        py: 'Zhonghanganmenglipei',
        jp: 'zhamlp',
        url: 'http://claim.groupama-avic.com.cn:7015/claim/',
        openUrlType: 200
      },
      '安盟保险定损系统': {
        url: 'http://10.28.7.30:8080/systemWeb/#/system/login',
        py: 'Zhonghanganmengdingsun',
        jp: 'zhamds',
        openUrlType: 200
      }
    }
  },
  '9825': {
    name: '中银',
    py: 'Zhongyin',
    jp: 'zy',
    color: '#AE1A3E',
    abb: '中银老系统',
    url: 'https://sol.bocins.com/ebs/security/login.jsp',
    logo: 'zhongyin.jpg',
    sortNum: 26,
    usable: true,
    specialConfigs: {
      '中银新系统': {
        url: 'http://cs.bocins.com:7001/prpall/index.jsp',
        py: 'Zhongyinx',
        jp: 'zyx'
      },
      '中银(新)': {
        url: 'http://che.bocins.com/new/#login',
        py: 'Zhongyinzx',
        jp: 'zyzx',
        openUrlType: 108
      },
      '中银(四川)': {
        url: 'http://buy.bocins.com/webone/index.html#login',
        py: 'Zhongyinsc',
        jp: 'zysc',
        openUrlType: 0
      }

    }

  },
  '9826': {
    name: '美亚',
    py: 'Meiya',
    url: '',
    sortNum: 27,
    jp: 'my'
  },
  '9827': {
    name: '三星',
    py: 'Sanxing',
    sortNum: 28,
    jp: 'sx',
    url: 'https://www.samsunganycar.com:8802/prpall/',
    color: '#023A97',
    logo: 'sanxing.jpg',
    usable: true,
    hasPlugins: true
  },
  /* "9828": { name: "众城", py: "Zhongcheng", url: "", sortNum: 29 }, */
  '9829': {
    name: '锦泰财产',
    py: 'Jintaicaichan',
    url: 'http://pcis.jtxt.ejintai.com/cbs_auto_policy/logon',
    color: '#003891',
    logo: 'jingtai.jpg',
    sortNum: 30,
    openUrlType: 1,
    usable: true,
    jp: 'jtcc'
  },
  '9830': {
    name: '安诚',
    py: 'Ancheng',
    jp: 'ac',
    url: 'http://ply.e-acic.com/pcis/core/pcis_main.jsp',
    color: '#CA1A24',
    logo: 'ancheng.jpg',
    sortNum: 31,
    usable: true,
    hasPlugins: true
  },
  '9831': {
    name: '安达',
    py: 'Anda',
    url: '',
    sortNum: 32
  },
  '9832': {
    name: '安心',
    py: 'Anxin',
    jp: 'ax',
    url: 'http://10.6.6.4:8080/pcisv7/core/pcis_main.jsp',
    color: '#EA992E',
    logo: 'anxin.png',
    sortNum: 33,
    usable: true,
    closeBrowser: true,
    specialConfigs: {
      '极速出单系统': {
        url: 'https://car.95303.com/apppc/#/',
        py: 'Jisu',
        jp: 'axjs',
        sharejobno: 1,
        openUrlType: 0
      },
      // "安心打印": {
      //     url: "https://print.95303.com/apicpt/login.jsp",
      //     py: "dayin",
      //     jp: "axdy",
      //     sharejobno: 1,
      //     openUrlType: 0
      // },
      '安心打印': {
        url: 'https://print.95303.com/axPrintShip/sys/home#page/printtask',
        py: 'dayin',
        jp: 'axdy',
        sharejobno: 1,
        openUrlType: 0
      },
      '安心B2B出单系统': {
        url: 'https://car.95303.com/n_apppc/#/login',
        py: 'dayin',
        jp: 'axdy',
        sharejobno: 1,
        openUrlType: 0
      }
    }
  },
  '9833': {
    name: '中路',
    py: 'Zhonglu',
    jp: 'zl',
    url: 'http://10.0.0.4/portal/default.jsp',
    color: '#1453A3',
    logo: 'zhonglu.jpg',
    sortNum: 34,
    vpn: true,
    hasPlugins: true,
    usable: true,
    specialConfigs: {
      '中路（新）': {
        py: 'Zhongluxing',
        jp: 'zlx',
        url: 'https://auto.zhlic.com.cn:18081/new-uauto-web/login.html',
        openUrlType: 0
      },
      '中路车险理赔系统': {
        py: 'Zhongluchexianlipei',
        jp: 'zlcxlp',
        url: 'https://aiclaim-zl.jryzt.com/docc/common/jumpindex.jsp',
        openUrlType: 0
      }
    }
  },
  '9834': {
    name: '久隆',
    py: 'Jiulong',
    url: '',
    sortNum: 35
  },
  '9835': {
    name: '合众',
    py: 'Hezhong',
    sortNum: 36,
    url: 'http://simple.hz-ins.cn/common/Login.jsp',
    color: '#03b790',
    logo: 'hezhong.jpg',
    openUrlType: 100,
    // sortNum: 31,
    usable: true
  },
  // "9836": { name: "安联", py: "Anlian", url: "", sortNum: 37 },
  '9837': {
    name: '信利',
    py: 'Xinli',
    url: '',
    sortNum: 38
  },
  '9838': {
    name: '易安',
    py: 'Yian',
    url: '',
    sortNum: 39
  },
  '9839': {
    name: '诚泰财产',
    py: 'Chengtaicaichan',
    jp: 'ctcc',
    url: 'http://e-chac.champion-ic.com/ipartner/login/user ',
    color: '#F6071C',
    logo: 'chengtai.jpg',
    sortNum: 40,
    usable: true,
    hasPlugins: true,
    openUrlType: 100
  },
  '9840': {
    name: '长江财产',
    py: 'Changjiangcaichan',
    jp: 'cjcc',
    url: 'http://pcis.cjbx.com.cn/',
    logo: 'changjiang.jpg',
    color: '#245E8C',
    sortNum: 41,
    vpn: true,
    usable: true,
    closeBrowser: true,
    hasPlugins: true
  },
  '9841': {
    name: '恒邦',
    py: 'Hengbang',
    url: 'http://10.1.2.242',
    color: '#B6894E',
    closeBrowser: true,
    sortNum: 42,
    logo: '',
    vpn: true,
    usable: true,
    hasPlugins: true,
    specialConfigs: {
      '恒邦代理出单系统': {
        url: 'http://order.hbins.com.cn',
        py: 'hbdlcd',
        jp: 'hbdlcd',
        sharejobno: 1,
        openUrlType: 100
      },
      '恒邦理赔管理系统': {
        url: 'http://10.1.2.242/index.jsp?_NCR=0.7627361360231535&_RECOVER_TOKEN=125e3e42-a5c2-4573-b354-acdcf1e44882',
        py: 'hblpgl',
        jp: 'hblpgl',
        sharejobno: 1,
        openUrlType: 100
      }
    }
  },
  '9842': {
    name: '富邦',
    py: 'Fubang',
    url: 'http://10.1.19.113:8001/quotation/index.jsp',
    logo: '',
    color: '#245E8C',
    vpn: true,
    usable: true,
    closeBrowser: true,
    sortNum: 43
  },
  '9843': {
    name: '中意财产',
    py: 'Zhongyicaichan',
    url: 'http://114.255.190.40:8001/pcis/core/login/realLogin.jsp', // "http://10.100.12.55:8001/pcis/core/pcis_main.jsp",
    color: '#BD3B43',
    sortNum: 44,
    logo: 'zhongyi.jpg',
    usable: true,
    vpn: true,
    openUrlType: 1,
    specialConfigs: {
      '网页版': {
        url: 'http://114.255.190.45:9001/sso/login?ReturnUrl=http://114.255.190.45:9001/frontend/#/dashboard',
        py: 'wyb',
        jp: 'zyx',
        sharejobno: 1,
        openUrlType: 0
      }
    }
  },
  // "9844": { name: "安徽中安财险", py: "Anhuizhongancaixian", jp: "ahzacx", url: "http://36.110.55.54/qcar/", color: "#099D49", usable: true, sortNum: 45, logo: "changan.jpg" },
  '9844': {
    name: '安徽中安财险',
    py: 'Anhuizhongancaixian',
    jp: 'ahzacx',
    color: '#F9632C',
    abb: '安徽中安财险',
    url: 'http://car.capli.com.cn/qcar',
    logo: 'changan.jpg',
    sortNum: 50,
    usable: true,
    openUrlType: 1,
    specialConfigs: {
      '长安(旧)': {
        url: 'http://36.110.55.54/qcar/',
        py: 'Changanj',
        jp: 'cax',
        sharejobno: 1,
        openUrlType: 1
      },
      '长安(新)': {
        url: 'http://111.207.173.186',
        py: 'Changanx',
        jp: 'cax',
        sharejobno: 1,
        openUrlType: 1
      }
    }
  },
  '9845': {
    name: '阳光渝融',
    py: 'Yangguangyurong',
    url: '',
    sortNum: 46
  },
  '9846': {
    name: '国泰财产',
    jp: 'gtcc',
    py: 'Guotaicaichan',
    url: 'http://uxcd.cathay-ins.com.cn/#/search/proposal/',
    color: '#029C53',
    sortNum: 47,
    logo: 'guotai.jpg',
    usable: true,
    openUrlType: 1,
    specialConfigs: {
      '极速出单系统': {
        py: 'Jisuchudanxitong',
        jp: 'jscdxt',
        sharejobno: 1,
        openUrlType: 0,
        url: 'http://sso.cathay-ins.com.cn/sso/login?appName=cxinscn_jscdapp&redirect=http://jscdux.cathay-ins.com.cn/#/dashboard'
      }
    }
  },
  '9847': {
    name: '中原农业',
    py: 'Zhongyuannongye',
    logo: 'zhongyuannongye.jpg',
    url: 'http://hxsso.zyic.com:83/login?ReturnUrl=http://carcb.zyic.com:83/frontend/#/dashboard',
    color: '#F08302',
    sortNum: 48,
    usable: true,
    openUrlType: 0
  },
  '9848': {
    name: '安华农业',
    py: 'Anhuanongye',
    jp: 'ahny',
    url: 'http://10.0.5.20:8001/prpins',
    logo: 'anhua.jpg',
    color: '#1e9c55',
    sortNum: 49,
    usable: true,
    openUrlType: 107,
    vpn: true,
    hasPlugins: true,
    closeBrowser: true,
    specialConfigs: {
      '安华农业(新)': {
        url: 'http://www.ahic.com.cn/web/b2b/web/index.jsp',
        py: 'Anhuanongyex',
        jp: 'ahnyx',
        sharejobno: 1,
        openUrlType: 1
      },
      '安华农业理赔管理系统': {
        url: 'http://10.0.5.20:7006/claim/',
        py: 'AnhuanongyeLPGL',
        jp: 'ahnylpgl',
        sharejobno: 1,
        openUrlType: 1
      }
    }
  },
  '9849': {
    name: '浙商财产',
    py: 'Zheshangcaichan',
    jp: 'zscc',
    color: '#97080A',
    abb: '浙商财产',
    url: 'https://core.zsins.com/pcis/core/main.jsp',
    logo: 'zheshang.jpg',
    sortNum: 50,
    usable: true,
    openUrlType: 1,
    hasPlugins: true,
    specialConfigs: {
      '浙商财产(新)': {
        url: 'http://www.ezsins.com/loginOn/vhl/car/premiumStepOne',
        py: 'Zheshangcaichanx',
        jp: 'zsccx',
        sharejobno: 1,
        openUrlType: 0
      }
    }
  },
  '9850': {
    name: '华海',
    py: 'Huahai',
    jp: 'hh',
    url: 'https://hx.huahaibaoxian.com:18000/cas/login?service=http%3A%2F%2Fhx.huahaibaoxian.com%3A8000%2Fpcisv7%2Fj_spring_security_check',
    color: '#0099e5',
    logo: 'huahai.jpg',
    sortNum: 51,
    usable: true,
    openUrlType: 1,
    hasPlugins: true,
    specialConfigs: {
      '华海(新)': {
        url: 'https://online.cnoic.com:18011/portal/',
        py: 'huahaixin',
        jp: 'hhx',
        sharejobno: 1,
        openUrlType: 0
      }
    }
  },
  // "9852": {
  //     name: "众安",
  //     py: "Zhongan",
  //     jp: "za",
  //     url: "https://c.zhongan.com/insure/index.html?flowId=FJ19519843665b96b622&i=e#/",
  //     color: "#38C675",
  //     logo: "zhongan.jpg",
  //     sortNum: 51,
  //     usable: true,
  //     openUrlType: 1,
  //     specialConfigs: {
  //         "单证打印": {
  //             url: "https://pacas-login.pingan.com.cn/cas/PA003/ICORE_PTS/login",
  //             py: "zhonganpingan",
  //             jp: "zapa",
  //             sharejobno: 1,
  //             openUrlType: 0
  //         },
  //     }
  // },
  '9852': {
    name: '众安',
    py: 'Zhonganpingan',
    jp: 'zapa',
    url: 'https://pacas-login.pingan.com.cn/cas/PA003/ICORE_PTS/login',
    color: '#38C675',
    logo: 'zhongan.jpg',
    sortNum: 51,
    usable: true,
    openUrlType: 0,
    specialConfigs: {
      '阿拉丁': {
        url: 'http://www.aldcx.com/lexus#/index',
        py: 'ald',
        jp: 'zapa',
        sharejobno: 1,
        openUrlType: 0
      }
    }
  },

  '9853': {
    name: '劳合社',
    py: 'Laoheshe',
    url: '',
    sortNum: 54
  },
  '9854': {
    name: '瑞再企商',
    py: 'Ruizaiqishang',
    url: '',
    sortNum: 55
  },
  '9855': {
    name: '日本兴亚',
    py: 'Ribenxingya',
    url: '',
    sortNum: 56
  },
  '9856': {
    name: '日本财产',
    py: 'Ribencaichan',
    url: '',
    sortNum: 57
  },
  '9857': {
    name: '东海航运',
    py: 'Donghaihangyun',
    url: '',
    sortNum: 58
  },
  '9858': {
    name: '东京海上',
    py: 'Dongjinghaishang',
    url: '',
    sortNum: 59
  },
  '9859': {
    name: '凯本',
    py: 'kaiben',
    url: '',
    sortNum: 60
  },
  '9860': {
    name: '现代财产',
    py: 'Xiandaicaichan',
    url: '',
    sortNum: 61
  },
  '9861': {
    name: '阳光农业',
    py: 'Yangguangnongye',
    jp: 'ygny',
    logo: 'yangguangnongye.png',
    url: 'http://10.0.116.10/sso/login?ReturnUrl=http://10.0.116.10/#/search/proposal/',
    color: '#DD7027',
    sortNum: 62,
    usable: true
  },
  '9862': {
    name: '爱和谊',
    py: 'Aiheyi',
    url: '',
    sortNum: 63
  },
  '9863': {
    name: '安信农业',
    py: 'Anxinnongye',
    url: '',
    sortNum: 64
  },
  '9864': {
    name: '都邦',
    py: 'Dubang',
    jp: 'db',
    url: 'https://bap.dbic.com.cn/prpall/index.jsp',
    color: '#998C00',
    logo: 'dubang.jpg',
    usable: true,
    sortNum: 65,
    hasPlugins: true
  },
  // "9865": {
  //     name: "鼎和财产",
  //     py: "Dinghecaichan",
  //     jp: "dhccx",
  //     color: "#0985F9",
  //     abb: "鼎和网销",
  //     url: "http://www.edhic.com/",
  //     logo: "dinghe.jpg",
  //     sortNum: 66,
  //     usable: true,
  //     openUrlType: 1,
  //     specialConfigs: {
  //         "鼎和财产(旧)": {
  //             url: "http://121.14.103.43:9009/prpcar/main/index",
  //             py: "Dinghecaichanj",
  //             jp: "dhcc",
  //             sharejobno: 1,
  //             openUrlType: 1
  //         }
  //     }
  // },
  '9865': {
    name: '鼎和财产',
    py: 'Dinghecaichan',
    jp: 'dhcc',
    color: '#0985F9',
    abb: '鼎和财产(旧)',
    url: 'http://121.14.103.43:9009/prpcar/main/logout',
    logo: 'dinghe.jpg',
    sortNum: 66,
    usable: true,
    openUrlType: 1,
    hasPlugins: true,
    specialConfigs: {
      '鼎和网销': {
        url: 'http://www.edhic.com/',
        py: 'Dinghecaichanx',
        jp: 'dhccx',
        sharejobno: 1,
        openUrlType: 100
      },
      '鼎和理赔系统': {
        url: 'http://121.14.103.43:9020/casserver/login;JSESSIONIDCLAIMCAR=M5inSnT1tQjQ5zLr5-pZtrvnkls4t9K39AaRURmqDahNNCgZBjiW!-694942137?service=http://121.14.103.43:9029/claimcar/cas',
        py: 'DingHeLiPeiGuanLi',
        jp: 'DHLPGL',
        sharejobno: 1,
        openUrlType: 100
      }
    }
  },
  '9866': {
    name: '国元农业',
    jp: 'gyny',
    py: 'Guoyuannongye',
    logo: 'guoyuannongye.jpg',
    color: '#119B4D',
    usable: true,
    hasPlugins: true,
    url: 'http://220.178.31.50:9010/carQuoteSystem/',
    sortNum: 67
  },
  '9867': {
    name: '史带财产',
    py: 'Shidaicaichan',
    url: '',
    sortNum: 68
  },
  '9871': {
    name: '民安',
    py: 'Minan',
    url: '',
    sortNum: 71
  },
  '9872': {
    name: '鑫安',
    py: 'Xinan',
    jp: 'xa',
    url: 'https://ecbs.sanguard.com.cn:9444/prpall/',
    color: '#401878',
    logo: 'xinan.jpg',
    sortNum: 72,
    usable: true
  },
  '9873': {
    name: '众诚',
    py: 'Zhongcheng',
    url: 'https://prd.urtrust.com.cn/car/home.html',
    color: '#D74C1A',
    logo: 'zhongcheng.jpg',
    usable: true,
    sortNum: 73,
    openUrlType: 0
  },
  '9875': {
    name: '利宝',
    py: 'Libao',
    jp: 'lb',
    url: 'https://lm.libertymutual.com.cn/insure/logout.do',
    ortNum: 75,
    color: '#012571',
    openUrlType: 0,
    logo: 'libao.jpg',
    usable: true,
    specialConfigs: {
      '利车保': {
        url: 'http://lcb.feizhubaoxian.com:40880/policyweb',
        py: 'Lichebao',
        jp: 'lcb',
        sharejobno: 1,
        openUrlType: 0
      }
    }
  },
  '9876': {
    name: '珠峰保险',
    py: 'Zhufeng',
    jp: 'zf',
    url: 'http://yi.zhufengic.com/ipartner/index',
    color: '#2ea7e0',
    openUrlType: 0,
    logo: 'zhufeng.jpg',
    sortNum: 76,
    usable: true
  },
  '9877': {
    name: '大地B2B',
    py: 'Dadib2b',
    jp: 'dd',
    url: 'http://b2b.ccic-net.com.cn/login/index.jsp',
    color: '#0A5E80',
    logo: 'dadi.jpg',
    sortNum: 77,
    usable: true
  },
  '9878': {
    name: '前海',
    py: 'Qianhai',
    jp: 'qh',
    url: 'http://pcis.qhins.com/pcisv7/core/pcis_main.jsp',
    color: '#002d7f',
    logo: 'qianhai.jpg',
    sortNum: 78,
    vpn: true,
    usable: true,
    specialConfigs: {
      '前海财险系统': {
        url: 'https://ptn.qhins.com/qauto-web/index.html',
        py: 'qianhaicaixianxitongqianhai',
        jp: 'qhcxxtqh',
        sharejobno: 1,
        openUrlType: 100
      }
    }

  },
  '9879': {
    name: '北部湾',
    py: 'Beibuwan',
    jp: 'bbw',
    url: 'http://10.0.1.120:8001/portal',
    color: '#794d86',
    logo: 'beibuwan.png',
    sortNum: 79,
    vpn: true,
    usable: true,
    specialConfigs: {
      '北部湾极速系统': {
        url: 'https://kscd.ebgic.com/proposal/insure',
        py: 'beibuwanjisu',
        jp: 'bbajs',
        sharejobno: 1,
        openUrlType: 100
      }
    }
  },
  '9881': {
    name: '海港人寿',
    py: 'Haigangrenshou',
    jp: 'hgrs',
    url: 'https://www.harbourlife.com.cn',
    color: '#1F1B8D',
    logo: '',
    sortNum: 81,
    vpn: true,
    usable: true
  },
  '9882': {
    name: '吉祥人寿',
    py: 'Jixiangrenshou',
    jp: 'bbw',
    url: 'http://www.jxlife.com.cn/web/index.jsp',
    color: '#794d86',
    logo: 'jixiangrenshou.png',
    sortNum: 82,
    vpn: true,
    usable: true
  },
  '9885': {
    name: '铁路自保',
    py: 'Tieluzibao',
    jp: 'bbw',
    url: 'http://www.china-ric.cn/',
    color: '#794d86',
    logo: 'tieluzibao.png',
    sortNum: 85,
    vpn: true,
    usable: true
  },
  '9886': {
    name: '建信',
    py: 'Jianxin',
    jp: 'bbw',
    url: 'http://www.ccbpi.com.cn/',
    color: '#794d86',
    logo: 'Jianxin.jpg',
    sortNum: 86,
    vpn: true,
    usable: true,
    specialConfigs: {
      '建信核心系统': {
        url: 'http://172.33.36.164:8098/#/login',
        py: 'jianxinhexinxitong',
        jp: 'jxhxxt',
        sharejobno: 1,
        openUrlType: 100
      }
    }
  },
  '9887': {
    name: '泰康在线',
    specialConfigs: {
      '泰康在线': {
        url: 'http://www.tk.cn/',
        py: 'Taikangzaixin',
        jp: 'lcb',
        sharejobno: 1,
        openUrlType: 0
      },
      '泰康在线便捷新网址': {
        url: 'http://t.tk.cn/tplatform_clientManage/cxLogin.do',
        py: 'Taikangzaixian',
        jp: 'lcb',
        sharejobno: 1,
        openUrlType: 0
      }
    },
    py: 'Taikang',
    jp: 'tk',
    url: 'http://core.car.tk.cn',
    color: '#2eb7a7',
    logo: 'taikangzaixian.jpg',
    sortNum: 87,
    vpn: true,
    usable: true
  },
  '9888': {
    name: '三井住友',
    py: 'Sanjinzhuyou',
    jp: 'bbw',
    url: 'http://www.ms-ins.com.cn',
    color: '#794d86',
    logo: '',
    sortNum: 88,
    vpn: true,
    usable: true
  },
  // "9889": { name: "鑫安汽车", py: "Xinanqiche", jp: "bbw", url: "http://www.sanguard.com.cn/", color: "#794d86", logo: "beibuwan.png", sortNum: 79, vpn: true, usable: true },
  '9890': {
    name: '中信保诚',
    py: 'Zhongxinbaocheng',
    jp: 'bbw',
    url: 'http://www.citic-prudential.com.cn/index.aspx',
    color: '#794d86',
    logo: 'Zhongxinbaocheng.png',
    sortNum: 90,
    vpn: true,
    usable: true
  },
  '9891': {
    name: '融盛',
    py: 'Rongsheng',
    jp: 'rs',
    url: 'http://10.18.8.190:7001',
    color: '#794d86',
    logo: 'Rongsheng.png',
    sortNum: 91,
    vpn: true,
    usable: true,
    specialConfigs: {
      '融盛快速出单系统': {
        url: 'https://chexian.erongsheng.com:11001/',
        py: 'rongshengkuaisuchudanxitong',
        jp: 'rskscdxt',
        sharejobno: 1,
        openUrlType: 0
      }
    }

  },
  '9836': {
    name: '京东安联',
    py: 'Jingdonganlian',
    url: 'https://eservice.allianz.cn/eMotor/faces/SearchPage.jspx?_adf.ctrl-state=8soot8nok_3',
    color: '#114D93',
    usable: true,
    sortNum: 92,
    openUrlType: 0
  },
  '9914': {
    name: '中路交通',
    py: 'Zhonglujiaotong',
    url: 'http://zhonglujiaotongaqtc.com/index.php?m=Admin&c=Login&a=login',
    usable: true,
    sortNum: 93,
    openUrlType: 0
  },
  '9921': {
    name: '黄河财险',
    py: 'HuangHeCaiXian',
    url: '',
    color: '#3299F6',
    usable: true,
    sortNum: 94,
    openUrlType: 0
  },
  '9922': {
    name: '横琴人寿',
    py: 'HengQinRenShou',
    url: '',
    usable: true,
    sortNum: 95,
    openUrlType: 0
  }
}

export const specialHebeiPartnerConfig = {
  '9801': {
    name: '河北人保',
    py: 'Renbaohebei',
    jp: 'rbhb',
    sortNum: 1,
    openUrlType: 1,
    url: 'https://10.134.138.112:8888/casserver/login?service=http%3A%2F%2F10.134.138.112%3A80%2Fportal%2Findex.jsp',
    usable: true,
    ukey: true,
    area: '河北'
  }
}
export const specialXinjiangPartnerConfig = {
  '9801': {
    name: '新疆人保',
    py: 'Renbaoxinjiang',
    sortNum: 1,
    openUrlType: 1,
    url: 'https://10.134.129.80:8888/casserver/login?service=http%3A%2F%2F10.134.129.80%3A80%2Fportal%2Findex.jsp',
    usable: true,
    ukey: true,
    area: '新疆'
  },
  '980101': {
    name: '人保营销(外)',
    py: 'Renbaoxinjiangyingxiaoxitongwaiwang',
    jp: 'xjrbyxxtww',
    sortNum: 1,
    openUrlType: 0,
    url: 'http://157.122.153.67:9000/khyx/',
    usable: true,
    isfav: true,
    area: '新疆'
  },
  '980102': {
    name: '人保营销(内)',
    py: 'Renbaoxinjiangyingxiaoxitongneiwang',
    sortNum: 1,
    jp: 'xjrbyxxtnw',
    openUrlType: 0,
    isfav: true,
    url: 'http://10.133.240.239:9000/khyx/login.jsp;jsessionid=k9K4WC1GQr6s2LM0nG7pDVhc6G8vQHj6bhbCWw8GwJFny1vDQS4H!1140367973',
    usable: true,
    area: '新疆'
  }
}
export const specialShanxiPartnerConfig = {
  '9801': {
    name: '陕西人保',
    py: 'Renbaoshanxi',
    jp: 'rbsxi',
    sortNum: 1,
    openUrlType: 1,
    url: 'https://10.134.131.80:8888/casserver/login?service=http%3A%2F%2F10.134.131.80%3A80%2Fportal%2Findex.jsp',
    usable: true,
    ukey: true,
    area: '陕西'
  }
}
export const specialShanxPartnerConfig = {
  '9801': {
    name: '山西人保',
    py: 'Renbaoshanx',
    jp: 'rbsx',
    sortNum: 1,
    openUrlType: 1,
    url: 'https://10.134.134.144:8888/casserver/login?service=http%3A%2F%2F10.134.134.144%3A8000%2Fprpall%2Findex.jsp%3F__sys__%3D2',
    usable: true,
    ukey: true,
    area: '山西'
  },
  '980103': {
    name: '人保综合',
    py: 'Renbaozonghe',
    jp: 'rbzh',
    sortNum: 1,
    openUrlType: 1,
    url: 'http://10.134.134.144/portal/index.jsp',
    usable: true,
    ukey: true,
    area: '山西'
  },
  '980104': {
    name: '人保单证',
    py: 'Renbaodanzheng',
    jp: 'zrbdz',
    sortNum: 1,
    openUrlType: 1,
    url: 'http://10.134.134.144:8900/visa',
    usable: true,
    ukey: true,
    area: '山西'
  }

}
export const specialHenanPartnerConfig = {
  '9801': {
    name: '河南人保',
    py: 'Renbaohenan',
    jp: 'rbhn',
    sortNum: 1,
    openUrlType: 107,
    url: 'https://10.134.132.176:8888/casserver/login?service=http%3A%2F%2F10.134.132.176%3A80%2Fportal%2Findex.jsp',
    usable: true,
    ukey: true,
    area: '河南'
  },
  '9803': {
    name: '河南平安(新)',
    py: 'Pinganhenan',
    jp: 'pahn',
    sortNum: 3,
    openUrlType: 0,
    url: 'https://icorepnbs.pingan.com.cn/icore_pnbs/extranet_login.jsp',
    usable: true,
    area: '河南'
  },
  '980301': {
    name: '河南平安',
    py: 'Pinganhenan',
    jp: 'pahn',
    sortNum: 3,
    openUrlType: 0,
    url: 'https://icore-pts.pingan.com.cn/ebusiness/j_security_check',
    usable: true,
    area: '河南'
  },
  '980302': {
    name: '平安创展',
    py: 'Pinganchuanzhan',
    jp: 'pahn',
    sortNum: 3,
    openUrlType: 0,
    url: 'http://pacz.pa18.com/pacz_core/login.jsp',
    usable: true,
    area: '河南'
  },
  '9816': {
    name: '河南大地',
    py: 'Dadihenan',
    jp: 'ddhn',
    sortNum: 8,
    openUrlType: 1,
    url: 'http://b2b.ccic-net.com.cn/mcs/view/main.jsp',
    usable: true,
    area: '河南'
  },
  '9869': {
    name: '河南渤海',
    py: 'Bohaihenan',
    jp: 'bhhn',
    vpn: true,
    url: 'http://spcc.bpic.com.cn/app/#/',
    sortNum: 70,
    usable: true,
    area: '河南',
    openUrlType: 0
  }
}
export const specialJilinPartnerConfig = {
  '9801': {
    name: '吉林人保',
    py: 'Renbaojilin',
    jp: 'rbjl',
    sortNum: 1,
    openUrlType: 1,
    url: 'https://10.134.130.80:8888/casserver/login?service=http%3A%2F%2F10.134.130.80%3A80%2Fportal%2Findex.jsp',
    usable: true,
    ukey: true,
    area: '吉林'
  },
  '9803': {
    name: '吉林平安(新)',
    py: 'Pinganjilin',
    jp: 'pajl',
    sortNum: 3,
    openUrlType: 0,
    url: 'https://icorepnbs.pingan.com.cn/icore_pnbs/extranet_login.jsp',
    usable: true,
    area: '吉林'
  },
  '9810': {
    name: '吉林华安',
    py: 'Huaanjilin',
    jp: 'hajl',
    sortNum: 4,
    openUrlType: 1,
    url: 'https://auto.sinosafe.com.cn/index.jsp',
    usable: true,
    area: '吉林'
    // logo: "huaan.jpg"
  }
}
export const specialShandongPartnerConfig = {
  '9801': {
    name: '山东人保',
    py: 'Renbaoshandong',
    jp: 'rbsd',
    sortNum: 1,
    openUrlType: 1,
    url: 'https://10.134.136.80:8888/casserver/login?service=http%3A%2F%2F10.134.136.80%3A80%2Fportal%2Findex.jsp',
    usable: true,
    ukey: true,
    area: '山东'
  },
  '980101': {
    name: '青岛人保',
    py: 'Renbaoqingdao',
    jp: 'rbqd',
    sortNum: 2,
    openUrlType: 1,
    url: 'https://10.134.134.48:8888/casserver/login?service=http%3A%2F%2F10.134.134.48%3A80%2Fportal%2Findex.jsp',
    usable: true,
    ukey: true,
    area: '山东'
  },
  '980102': {
    name: '人保营销',
    py: 'Renbaoshandongyingxiaoxitong',
    sortNum: 1,
    jp: 'sdrbyxxt',
    openUrlType: 108,
    isfav: false,
    url: 'http://157.122.153.67:9000/khyx/',
    usable: true,
    area: '山东'
  },
  '9816': {
    name: '山东大地',
    py: 'Dadishandong',
    jp: 'ddsd',
    sortNum: 8,
    openUrlType: 1,
    url: 'http://b2b.ccic-net.com.cn/mcs/view/main.jsp',
    usable: true,
    area: '山东'
  },
  // "9802": {
  //    name: "山东太平洋",
  //    py: "Taibaoshandong",
  //    jp: "tpysd",
  //    sortNum: 8,
  //    openUrlType: 1,
  //    url: "http://10.190.48.28/CPIC09Auto/pages/loginView.jsp",
  //    usable: true,
  //    area: "山东"
  // },
  '9833': {
    name: '山东中路',
    py: 'Zhonglushandong',
    jp: 'zlsd',
    sortNum: 34,
    vpn: true,
    openUrlType: 1,
    url: 'http://10.0.0.4/portal/default.jsp',
    usable: true,
    area: '山东'

  }
}
export const specialJiangxiPartnerConfig = {
  '9801': {
    name: '江西人保',
    py: 'Renbaojiangxi',
    jp: 'rbjx',
    sortNum: 1,
    openUrlType: 1,
    url: 'https://10.134.132.48:8888/casserver/login?service=http%3A%2F%2F10.134.132.48%3A80%2Fportal%2Findex.jsp',
    usable: true,
    ukey: true,
    area: '江西'
  }
}
export const specialHunanPartnerConfig = {
  '9801': {
    name: '湖南人保',
    py: 'Renbaohunan',
    jp: 'rbhn',
    sortNum: 1,
    openUrlType: 1,
    url: 'https://10.134.132.16:8888/casserver/login;jsessionid=Gf53ZRpTFQYC2QTHmDk1vLlpH7pQgy1Gd81KwF21DyTbJkh15dhG!-504479112?service=http%3A%2F%2F10.134.132.16%3A80%2Fportal%2Findex.jsp',
    usable: true,
    ukey: true,
    area: '湖南'
  }
}
export const specialGuizhouPartnerConfig = {
  '9801': {
    name: '贵州人保',
    py: 'Renbaohunan',
    jp: 'rbhn',
    sortNum: 1,
    openUrlType: 1,
    url: 'https://10.134.134.176:8888/casserver/login;jsessionid=Gf53ZRpTFQYC2QTHmDk1vLlpH7pQgy1Gd81KwF21DyTbJkh15dhG!-504479112?service=http%3A%2F%2F10.134.134.176%3A80%2Fportal%2Findex.jsp',
    usable: true,
    ukey: true,
    area: '贵州'
  }
}
export const specialHeiLongJiangPartnerConfig = {
  '9801': {
    name: '黑龙江人保',
    py: 'Renbaoheilongjiang',
    jp: 'rbhlj',
    sortNum: 1,
    openUrlType: 1,
    url: 'https://10.134.130.16:8888/casserver/login?service=http%3A%2F%2F10.134.130.16%3A80%2Fportal%2Findex.jsp',
    usable: true,
    ukey: true,
    area: '黑龙江省'
  }
}
export const specialHubeiPartnerConfig = {
  '9801': {
    name: '湖北人保',
    py: 'Renbaohubei',
    jp: 'rbhb',
    sortNum: 1,
    openUrlType: 107,
    url: 'https://10.134.134.80:8888/casserver/login?service=http%3A%2F%2F10.134.134.80%3A80%2Fportal%2Findex.jsp',
    usable: true,
    ukey: true,
    area: '湖北'
  },
  '9805': {
    name: '湖北中华联合',
    py: 'Zhonghualianhehubei',
    jp: 'zhlhhb',
    sortNum: 4,
    openUrlType: 1,
    usable: true,
    url: 'http://10.192.0.22',
    area: '湖北',
    specialConfigs: {
      '中华联合影像': {
        url: 'http://222.33.33.27:88/',
        py: 'zhonghualianheyingxiang',
        jp: 'zhlhyx',
        openUrlType: 0
      }
    }
  },
  '9803': {
    name: '湖北平安(新)',
    py: 'Pinganhubei',
    jp: 'pahb',
    sortNum: 3,
    openUrlType: 0,
    url: 'https://icorepnbs.pingan.com.cn/icore_pnbs/extranet_login.jsp',
    usable: true,
    area: '湖北'
  }
}
export const specialGuangdongPartnerConfig = {
  '9813': {
    name: '广东阳光',
    py: 'Yangguangguangdong',
    jp: 'yggd',
    sortNum: 11,
    openUrlType: 1,
    url: 'http://10.10.0.20/prpall/index.jsp',
    usable: true,
    area: '广东'
  }
}
export const specialSiChuanPartnerConfig = {
  '9803': {
    name: '平安(新)',
    py: 'Pingansichuan',
    jp: 'pajl',
    sortNum: 3,
    openUrlType: 0,
    url: 'https://icorepnbs.pingan.com.cn/icore_pnbs/extranet_login.jsp',
    usable: true,
    area: '四川'
  },
  '9801': {
    name: '四川人保',
    py: 'Renbaosichuan',
    jp: 'rbsc',
    sortNum: 1,
    openUrlType: 1,
    url: 'https://10.134.138.16:8888/casserver/login?service=http%3A%2F%2F10.134.138.16%3A80%2Fportal%2Findex.jsp',
    usable: true,
    ukey: true,
    area: '四川'
  }

}
export const specialBeijingPartnerConfig = {
  '9801': {
    name: '北京人保',
    py: 'Renbaobeijing',
    jp: 'rbbj',
    sortNum: 1,
    openUrlType: 1,
    url: 'https://10.134.136.48:8888/casserver/login?service=http%3A%2F%2F10.134.136.48%3A8000%2Fprpall%2Findex.jsp',
    usable: true,
    ukey: true,
    area: '北京'
  },
  '9805': {
    name: '北京中华联合',
    py: 'Zhonghualianhebeijing',
    jp: 'zhlhbj',
    sortNum: 4,
    openUrlType: 0,
    usable: true,
    url: 'http://10.192.0.22/pcis/core/pcis_main.jsp', // "http://10.192.32.69:8001/pcis/core/pcis_main.jsp",
    area: '北京'
  }
}
export const specialTianjinPartnerConfig = {
  '9801': {
    name: '天津人保',
    py: 'Tianjinbeijing',
    jp: 'rbtj',
    sortNum: 1,
    openUrlType: 1,
    url: 'https://10.134.131.48:8888/casserver/login?service=http%3A%2F%2F10.134.131.48%3A80%2Fportal%2Findex.jsp',
    usable: true,
    ukey: true,
    area: '天津'
  }
}
export const specialLiaoNingPartnerConfig = {
  '9801': {
    name: '辽宁人保',
    py: 'Renbaoliaoning',
    jp: 'rbtj',
    sortNum: 1,
    openUrlType: 1,
    url: 'https://10.134.129.16:8888/casserver/login?service=http%3A%2F%2F10.134.129.16%3A80%2Fportal%2Findex.jsp',
    usable: true,
    ukey: true,
    area: '辽宁'
  }
}

export const provincenames = {
  '00101': {
    'name': '北京市',
    'abb': '京'
  },
  '00102': {
    'name': '上海市',
    'abb': '沪'
  },
  '00103': {
    'name': '天津市',
    'abb': '津'
  },
  '00104': {
    'name': '重庆市',
    'abb': '渝'
  },
  '00105': {
    'name': '河北省',
    'abb': '冀'
  },
  '00106': {
    'name': '山西省',
    'abb': '晋'
  },
  '00107': {
    'name': '内蒙古',
    'abb': '蒙'
  },
  '00108': {
    'name': '福建省',
    'abb': '闽'
  },
  '00109': {
    'name': '吉林省',
    'abb': '吉'
  },
  '00110': {
    'name': '黑龙江省',
    'abb': '黑'
  },
  '00111': {
    'name': '江苏省',
    'abb': '苏'
  },
  '00112': {
    'name': '浙江省',
    'abb': '浙'
  },
  '00113': {
    'name': '安徽省',
    'abb': '皖'
  },
  '00114': {
    'name': '辽宁省',
    'abb': '辽'
  },
  '00115': {
    'name': '江西省',
    'abb': '赣'
  },
  '00116': {
    'name': '山东省',
    'abb': '鲁'
  },
  '00117': {
    'name': '河南省',
    'abb': '豫'
  },
  '00118': {
    'name': '湖北省',
    'abb': '鄂'
  },
  '00119': {
    'name': '湖南省',
    'abb': '湘'
  },
  '00120': {
    'name': '广东省',
    'abb': '粤'
  },
  '00121': {
    'name': '广西',
    'abb': '桂'
  },
  '00122': {
    'name': '海南省',
    'abb': '琼'
  },
  '00123': {
    'name': '四川省',
    'abb': '川'
  },
  '00124': {
    'name': '贵州省',
    'abb': '贵'
  },
  '00125': {
    'name': '云南省',
    'abb': '云'
  },
  '00126': {
    'name': '西藏',
    'abb': '藏'
  },
  '00127': {
    'name': '陕西省',
    'abb': '陕'
  },
  '00128': {
    'name': '甘肃省',
    'abb': '甘'
  },
  '00129': {
    'name': '宁夏',
    'abb': '宁'
  },
  '00130': {
    'name': '青海省',
    'abb': '青'
  },
  '00131': {
    'name': '新疆',
    'abb': '新'
  },
  '00132': {
    'name': '台湾',
    'abb': '台'
  },
  '00133': {
    'name': '澳门',
    'abb': '澳'
  },
  '00134': {
    'name': '香港',
    'abb': '港'
  }
}
export default {
  apiUri: 'http://insapi.kelaibao.net/api/partner',
  configs: partnerConfig,
  provincenames: provincenames,
  specialConfigs: [specialHebeiPartnerConfig, specialHenanPartnerConfig, specialShandongPartnerConfig, specialJiangxiPartnerConfig, specialHunanPartnerConfig, specialHubeiPartnerConfig, specialGuangdongPartnerConfig, specialJilinPartnerConfig, specialShanxiPartnerConfig, specialSiChuanPartnerConfig, specialXinjiangPartnerConfig, specialShanxPartnerConfig, specialBeijingPartnerConfig, specialTianjinPartnerConfig, specialLiaoNingPartnerConfig, specialGuizhouPartnerConfig, specialHeiLongJiangPartnerConfig]
}



// WEBPACK FOOTER //
// ./src/data/partners.js